import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";

const SkeletonCard = () => (
  <Box
    sx={{
      width: "100%",
      borderRadius: 2,
      border: "1px solid #E0E0E0",
      display: "flex",
      overflow: "hidden",
      boxShadow: "0px 2px 12px rgba(0,0,0,0.12)",
      backgroundColor: "#fff",
    }}
  >
    {/* Left status border */}
    <Skeleton variant="rectangular" width={6} sx={{ flexShrink: 0, minHeight: 190 }} />

    <Box sx={{ p: 2, width: "100%" }}>
      {/* Avatar + name + status chip row */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Skeleton variant="circular" width={36} height={36} />
          <Box>
            <Skeleton width={110} height={20} />
            <Skeleton width={60} height={16} sx={{ mt: 0.5 }} />
          </Box>
        </Stack>
        <Skeleton variant="rounded" width={70} height={30} sx={{ borderRadius: "10px" }} />
      </Stack>

      {/* Dept / Shift / Duration row */}
      <Stack direction="row" spacing={2} mt={1}>
        <Skeleton width="33%" height={18} />
        <Skeleton width="33%" height={18} />
        <Skeleton width="33%" height={18} />
      </Stack>

      {/* Check In / Check Out / Worked Hours */}
      <Stack direction="row" spacing={1} mt={2}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{ flex: 1, border: "1px solid #eee", borderRadius: 2, p: 1, textAlign: "center" }}
          >
            <Skeleton width="65%" height={14} sx={{ mx: "auto" }} />
            <Skeleton width="50%" height={22} sx={{ mx: "auto", mt: 0.5 }} />
            <Skeleton width="60%" height={14} sx={{ mx: "auto", mt: 0.5 }} />
          </Box>
        ))}
      </Stack>

      {/* Overtime / Late row */}
      <Stack direction="row" justifyContent="center" spacing={4} mt={2}>
        <Skeleton width={80} height={16} />
      </Stack>
    </Box>
  </Box>
);

export default SkeletonCard;
